import Container from './Container'

export default class Row extends Container {
    static cn = 'row g15'
    render() {
        return this.wrapper(this.props.children)
    }
}